import { Quota } from '../objects/quota';
import { Config } from '../objects/config';
import { ClientBranchCompany } from '../../margin/objects/company';
import { HeaderActionTypes, SET_AVAILABLE_CLIENT_BRANCHES, SET_CONFIG, SET_GOOGLE, TOGGLE_IS_BI, UPDATE_QUOTA } from './actionTypes';

export const setConfig = (config: Config): HeaderActionTypes => ({
    type: SET_CONFIG,
    payload: config
});

export const setGoogle = (google: any): HeaderActionTypes => ({
    type: SET_GOOGLE,
    payload: google
});

export const updateQuota = (quota: Quota): HeaderActionTypes => ({
    type: UPDATE_QUOTA,
    payload: quota
});

export const toggleIsBi = (isBi: boolean): HeaderActionTypes => ({
    type: TOGGLE_IS_BI,
    payload: isBi
});

export const setAvailableClientBranches = (branches: ClientBranchCompany[]): HeaderActionTypes => ({
    type: SET_AVAILABLE_CLIENT_BRANCHES,
    payload: branches
});